import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useClickAway } from 'ahooks';
import { not } from 'ramda';
import { FormattedMessage } from 'react-intl';
import { Button, Spin } from 'antd';
import ChatSVG from 'assets/images/icons/chat.svg';
import StyledDropdown from 'Common/Components/Dropdown';

const IntercomProductTourId = '18112';

const SmallSpin = styled(Spin)`
  display: block;
  margin: 0 auto;
  transform: scale(0.5);
  transform-origin: center;
`;

const IntegrationsDropdown: React.FC<{ language: string }> = ({ language }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [intercomLoaded, setIntercomLoaded] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useClickAway(() => {
    setShowMenu(false);
  }, ref);

  useEffect(() => {
    if (language !== 'de') return undefined;

    if (window.Intercom) {
      setIntercomLoaded(true);
      return undefined;
    }

    const handleIntercomReady = () => {
      setIntercomLoaded(true);
    };

    window.addEventListener('intercom:ready', handleIntercomReady);

    const interval = setInterval(() => {
      if (window.Intercom) {
        setIntercomLoaded(true);
        clearInterval(interval);
      }
    }, 100);

    return () => {
      window.removeEventListener('intercom:ready', handleIntercomReady);
      clearInterval(interval);
    };
  }, [language]);

  return (
    <div>
      <span ref={ref}>
        <StyledDropdown width="150px">
          <Button
            icon={<ChatSVG css={{ fontSize: 25 }} />}
            css={`
              margin: 17px 15px auto 15px;
              border: none;
              box-shadow: none;
            `}
            onClick={() => setShowMenu(not)}
          />
          <div className={`menu ${showMenu ? 'visible' : 'hidden'}`}>
            <Button>
              <a
                href="https://help.shore.com/de"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage defaultMessage="Support Center" />
              </a>
            </Button>
            {window?.Intercom &&
              language === 'de' &&
              (!intercomLoaded ? (
                <SmallSpin style={{ display: 'flex', margin: '0 auto' }} />
              ) : (
                <Button
                  onClick={() =>
                    window.Intercom?.('startTour', IntercomProductTourId)
                  }
                >
                  <FormattedMessage defaultMessage="Product Tour" />
                </Button>
              ))}
          </div>
        </StyledDropdown>
      </span>
    </div>
  );
};

export default IntegrationsDropdown;
